'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateOffsetHeight = calculateOffsetHeight;

var _dimensions = require('../constants/dimensions');

function calculateOffsetHeight(_ref) {
  var showAvailabilityMessage = _ref.showAvailabilityMessage,
      mobile = _ref.mobile;

  var offsetHeight = showAvailabilityMessage ? _dimensions.OFFSET_HEIGHT_EXTENDED : _dimensions.OFFSET_HEIGHT;

  var mobileOffsetHeight = showAvailabilityMessage ? _dimensions.MOBILE_OFFSET_HEIGHT_EXTENDED : _dimensions.MOBILE_OFFSET_HEIGHT;

  return mobile ? mobileOffsetHeight : offsetHeight;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/widget-dimensions/util/calculateOffsetHeight.js
// module id = 1046
// module chunks = 2 3